import { SignupAcknowledgement } from "@components/signup/signup-acknowledgement";
import { PageTitle } from "@components/common/page-title";
import { UlmContainer } from "@components/ulm/ulm-container";
import { QueryParams } from "@router/route-params";
import { useSearchParams } from "react-router-dom";
import { InvitedStep } from "@pages/invited/invited-types";
import { useState } from "react";
import { InvitedStepEmail } from "@pages/invited/invited-step-email";
import { InvitedStepOne } from "@pages/invited/invited-step-one";
import { InvitedStepTwo } from "@pages/invited/invited-step-two";
import { RegisterableServer } from "@custom-types/server-types";

/**
 * Page component that handles registration flow for users invited
 * to join an existing workspace.
 * If the invitation link does not carry the email address, the user is
 * asked to enter it first.
 */
export function Invited(): JSX.Element {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState<string>(
    searchParams.get(QueryParams.email) ?? ""
  );
  const [server, setServer] = useState<RegisterableServer>();
  const [step, setStep] = useState<InvitedStep>(email ? "one" : "email");

  /** Stores the email and server validated in the email step */
  function setEmailAndServer(email: string, server: RegisterableServer): void {
    setEmail(email);
    setServer(server);
    setStep("one");
  }

  return (
    <UlmContainer>
      <PageTitle>Activate your account</PageTitle>
      {step === "email" && (
        <InvitedStepEmail setEmailAndServer={setEmailAndServer} />
      )}
      {step === "one" && (
        <InvitedStepOne email={email} server={server} setStep={setStep} />
      )}
      {step === "two" && <InvitedStepTwo email={email} setStep={setStep} />}
      <SignupAcknowledgement />
    </UlmContainer>
  );
}
